import Vue from "vue";

import fieldsetComponent from "@/components/child/form/fieldset.vue";
import { Component } from "@/decorators";
import CapaSeiModel from "@/models/capaSeiModel";
import CapaSEIService from "@/services/capaSEIService";

@Component({
    components: {
        fieldsetComponent,
    },
})
export default class CapaSeiComponent extends Vue {
    private service = new CapaSEIService();
    public modelOriginal = new CapaSeiModel();
    public model = new CapaSeiModel();

    public async insertUpdate() {
        return await this.service.insertUpdate(this.model).withLoading();
    }

    private async beforeMount() {
        this.model = (await this.service.get().withLoading().resolveWithJSON<CapaSeiModel>()) ?? this.model;
        this.modelOriginal = Object.assign({}, this.model);
    }

    public foiAlterado(): boolean {
        type CapaKey = keyof CapaSeiModel;

        return (Object.keys(this.model) as CapaKey[]).some(key => this.model[key] !== this.modelOriginal[key]);
    }
}
